<ngx-spinner></ngx-spinner>
<router-outlet>
</router-outlet>
<app-screenshot-overlay data-screenshot-ignore></app-screenshot-overlay>
<!-- Global: drawing-processing notifications, shown wherever the user is. -->
<app-drawing-notifications></app-drawing-notifications>
<!-- Global: floating audio mini-player, keeps playing across CRM navigation. -->
<app-audio-mini-player></app-audio-mini-player>
<!-- <fa-icon [icon]="faCoffee"></fa-icon> -->
<!-- <a><i class="fas fa-phone"></i></a> -->
